import helpers from '../util/helpers';

export default{
  init() {
    $(window).on('load', function() {
      if (window.location.hash) {
        history.replaceState(null, null, ' ');
      }
    });

    $('a[href^="#"]').on('click', function(event) {
      event.preventDefault();

      const target = $(this.getAttribute('href'));

      if (target.length) {
        $('html, body').animate({
          scrollTop: target.offset().top }, 800);
      }
    });

    const body = $('body');
    // Hotel Eat & Drink Reservation
    const hotelEatAndDrinkReservationModal = $('.eat-drink-modal');
    if (hotelEatAndDrinkReservationModal.length) {
      $(document).on('click', '.eat-drink-modal-trigger, .eat-drink-modal-close', function(e) {
        e.preventDefault();
        body.toggleClass('eat-drink-modal-mode');
        return false;
      });

      $(document).on('wpcf7invalid', function() {
        let requiredSelectField = hotelEatAndDrinkReservationModal.find('select.wpcf7-validates-as-required');
        if (requiredSelectField.length) {
          requiredSelectField.each(function() {
            let _this = $(this);

            if (_this.val() === '') {
              _this.addClass('wpcf7-not-valid');
            } else {
              _this.removeClass('wpcf7-not-valid');
            }
          });
        }
      });

      $(document).on('keydown', function(e) {
        if (body.hasClass('eat-drink-modal-mode')) {
          if (e.key === 'Escape') {
            body.removeClass('eat-drink-modal-mode');
            helpers.stopBodyScrolling(false);
          }
        }
      });
    }

    const eatAndDrinkMenusSelect = $('.eat-and-drink-menus-select');
    if (eatAndDrinkMenusSelect.length) {
      eatAndDrinkMenusSelect.on('select2:select', function () {
        const _this = $(this);
        const selectedVal = _this.val();

        if (selectedVal) {
          window.open(selectedVal, '_blank');
        }
      });
    }
  },
  finalize() {},
};



// WEBPACK FOOTER //
// ./scripts/routes/singleCptEatDrink.js